import { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import {
    TrashIcon,
} from "@heroicons/react/24/solid"
import { PaginationState, createColumnHelper } from "@tanstack/react-table"
import { Tooltip } from "flowbite-react"
import Modal from "components/ui/modal/Modal"
import ReactTable from "components/ui/react-table/ReactTable"
import Button from "components/ui/button/Button"
import type { SertifikatProgram } from "utils/api/cms/types"
import EmployeeDashboardWrapper from "components/layouts/EmployeeDashboardWrapper"
import ButtonWithIcon from "components/ui/button/ButtonWithIcon"
import Typography from "components/ui/typography"
import { toast } from "react-toastify"
import { CMSSertifikatProgramListResponse } from "utils/types"
import useGetSertifikatProgram from "utils/api/cms/queries/hooks/useGetSertifikatProgram"
import useDeleteProgramSertifikat from "utils/api/cms/mutations/hooks/useDeleteProgramSertifikat"

const SertifikatDetailForm = () => {
    const params = useParams()
    const [pagination, setPagination] = useState<PaginationState>({
        pageIndex: 0,
        pageSize: 1,
    })
    const [lastPage, setLastPage] = useState(1)
    const [sertifikatResponse, setSertifikatResponse] =
        useState<CMSSertifikatProgramListResponse<SertifikatProgram>>()
    const [searchFilter, setSearchFilter] = useState("")
    const [perPageLimit, setPerPageLimit] = useState(10)
    const [dataSertifikat, setDataSertifikat] = useState<SertifikatProgram[]>([])
    const [modalSertifikat, setModalSertifikat] = useState<{
        isOpen: boolean
        sertifikatID: string
    }>()

    const { data: resultResponse } = useGetSertifikatProgram({
        options: {
            staleTime: 0,
        },
        qParams: {
            limit: perPageLimit,
            page: pagination.pageIndex + 1,
            keyword: searchFilter,
            sertifikat_id: Number(params.id)
        },
    })

    useEffect(() => {
        setSertifikatResponse(resultResponse)
        setDataSertifikat(resultResponse?.data || [])
        setLastPage(resultResponse?.meta?.last_page || 1)
    }, [resultResponse])

    const handleModalSertifikat = (sertifikatId?: string) => {
        setModalSertifikat((prev) => ({
            isOpen: !prev?.isOpen,
            sertifikatID: sertifikatId ?? ""
        }))
    }

    const { mutate: mutateDeleteSlide, isLoading } = useDeleteProgramSertifikat({
        onSuccess(data, variables) {
            handleModalSertifikat()
            toast.success("Berhasil hapus sertifikat detail")
            setDataSertifikat((prev) => prev.filter((d) => d.id !== Number(variables.sertifikatId)));
        },
    })


    const sertifikatColumnHelper = createColumnHelper<SertifikatProgram>()

    const sertifikatColumns = [
        sertifikatColumnHelper.accessor("name", {
            header: "Nama",
            cell: (props) => props.getValue(),
        }),
        sertifikatColumnHelper.accessor("code", {
            header: "Kode",
            cell: (props) => props.getValue(),
        }),
        sertifikatColumnHelper.accessor("type", {
            header: "Tipe",
            cell: (props) => props.getValue(),
        }),
        sertifikatColumnHelper.display({
            id: "actions",
            header: "Aksi",
            cell: (props) => (
                <div className="flex flex-row w-fit space-x-3">
                    <Tooltip content="Delete">
                        <ButtonWithIcon
                            class="mx-auto border-2 border-transparent bg-red-600 text-white hover:bg-red-500 hover:border-red-500"
                            type="button"
                            action={(e: React.MouseEvent<HTMLButtonElement>) => {
                                e.preventDefault()
                                handleModalSertifikat(
                                    props.row.original.id.toString(),
                                )
                            }}
                            sizeClass="p-1"
                        >
                            <TrashIcon className="h-5 w-5" />
                        </ButtonWithIcon>
                    </Tooltip>
                </div>

            ),
        }),
    ]

    return (
        <EmployeeDashboardWrapper>
            <ReactTable
                columns={sertifikatColumns}
                data={dataSertifikat ?? []}
                pagination={pagination}
                onPaginationChange={setPagination}
                pageCount={lastPage}
            />

            <Modal
                header="Delete Slide"
                onclose={handleModalSertifikat}
                show={!!modalSertifikat?.isOpen}
                body={
                    <Typography className="text-white">
                        Apakah Anda yakin untuk menghapus sertifikat detail ini
                    </Typography>
                }
                footer={
                    <div className="space-x-2 ml-auto">
                        <Button
                            onClick={() => handleModalSertifikat()}
                            variant="outlined"
                            className="text-gray-300 border-gray-300"
                        >
                            Batal
                        </Button>
                        <Button
                            isLoading={isLoading}
                            onClick={() =>
                                mutateDeleteSlide({
                                    sertifikatId: modalSertifikat?.sertifikatID ?? "",
                                })
                            }
                        >
                            Hapus
                        </Button>
                    </div>
                }
            />
        </EmployeeDashboardWrapper>
    )
}

export default SertifikatDetailForm
